import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconKeyboardUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconKeyboardUp"><Path d="M11.9999 4.06053L13.9999 6.06053L15.0605 4.99987L11.9999 1.93921L8.93923 4.99987L9.99989 6.06053L11.9999 4.06053Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M1 7.99998V22H23V7.99998H1ZM9 16.5H15V18H9V16.5ZM6.5 16.5H5V18H6.5V16.5ZM5 12H6.5V13.5H5V12ZM10.5 12H9V13.5H10.5V12ZM13.5 12H15V13.5H13.5V12ZM19.0002 12H17.5002V13.5H19.0002V12ZM17.5 16.5H19V18H17.5V16.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconKeyboardUp;
